<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="windowService.isDesktopRes ? report?.name : 'Reports'"
      [canGoBack]="!windowService.isDesktopRes"
      [customBack]="'more'"
      [showLinkIcon]="windowService.isDesktopRes"
      [linkIcon]="'settings-outline'"
      (linkAction)="goToReportSettings()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header style="height: 51px">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-white.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Reports'" />
          <form [formGroup]="dateRangeForm" novalidate action="#" class="form-filters">
            <tidy-header-select
              [items]="reportFilterItems"
              [form]="dateRangeForm.get('type')"
              formControlName="type"
              (optionChange)="changeReportFilter($event)"
              [icon]="'assets/svg/list.svg'" />
            <tidy-header-datepicker
              (customDateOption)="saveCustomDateFilter($event)"
              (stringDateOption)="saveStringDateFilter($event)"
              [(dateRangeForm)]="dateRangeForm"
              [rangeOption]="dateFilter?.value?.includes('from') ? 'custom' : ''"
              [header]="true"
              [icon]="'assets/svg/calendar.svg'" />
          </form>
          <tidy-small-button
            [text]="'Add Report'"
            [image]="'assets/img/add-white.svg'"
            (buttonClick)="goToAddReport()" />
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            (action)="exportCSV()"
            class="desktop-header-icon secondary-text-icon" />
          <tidy-image
            [src]="'assets/img/gear.svg'"
            (action)="goToReportSettings()"
            class="desktop-header-icon secondary-text-icon" />
        </div>
      </tidy-desktop-header>
    }

    @if (!windowService.isDesktopRes) {
      <tidy-row [alignLastItemRight]="true">
        <form [formGroup]="dateRangeForm" novalidate action="#" class="form-filters">
          <tidy-header-select
            [items]="reportFilterItems"
            [form]="dateRangeForm.get('type')"
            formControlName="type"
            (optionChange)="changeReportFilter($event)"
            [icon]="'assets/svg/list.svg'" />
          <tidy-header-datepicker
            (customDateOption)="saveCustomDateFilter($event)"
            (stringDateOption)="saveStringDateFilter($event)"
            [(dateRangeForm)]="dateRangeForm"
            [rangeOption]="dateFilter?.value?.includes('from') ? 'custom' : ''"
            [header]="true"
            [icon]="'assets/svg/calendar.svg'" />
        </form>
        <tidy-image
          [src]="'assets/img/settings.svg'"
          class="title-size"
          (action)="goToReportSettings()" />
      </tidy-row>
      @if (!tableLoaded) {
        <div style="width: 100%; padding-top: 1rem;">
          <ion-skeleton-text
            animated="true"
            style="height: 200px; border-radius: 6px" />
        </div>
        <div style="width: 100%;">
          <ion-skeleton-text
            animated="true"
            style="height: 200px; border-radius: 6px" />
        </div>
      }
    }
    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (windowService.isDesktopRes && !tableLoaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }
    @if (tableLoaded) {
      @if (rows?.length > 0) {
        <tidy-table
          #tidyTable
          [dataSource]="currentRows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          (sortChange)="sortChanged($event)"
          [showColumnLines]="false"
          [rowsToShow]="50"
          [infiniteScroll]="true"
          [totalRows]="rows?.length"
          (pageChange)="pageChange($event)"
          [showArrowIcon]="false"
          [skipEntrance]="true"
          [blockSorting]="true" />
      }
      @if (!rows?.length) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'There are no results for this report.'" />
          </tidy-row>
        </tidy-alert>
      }
      @for (card of nudgeCards; track card) {
        <tidy-card style="padding: 15px 15px 15px 5px">
          <tidy-card-button (action)="goToPage(card?.destination)">
            <tidy-grid>
              <tidy-row>
                <ion-row>
                  <ion-col size="2" class="vertical-align-center">
                    <div style="margin:auto">
                      <tidy-image
                        [src]="card?.icon"
                        [ngStyle]="{'width': card?.iconWidth}" />
                    </div>
                  </ion-col>
                  <ion-col tidySize="5">
                    <tidy-row>
                      <tidy-text
                        [header]="card?.header" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="card?.body" />
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-row>
            </tidy-grid>
          </tidy-card-button>
        </tidy-card>
      }
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />